import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { track } from '../../amplitude';
import { Feilmelding } from '../../amplitude/ampli';
import { isDebug } from '../../hn-debug';
import { HelsenorgeProxyError } from '../../hn-proxy-service';
import { error as logError } from '../../logger';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }
    componentDidCatch(error) {
        track(new Feilmelding({
            handling: 'systemevent',
            feiltype: 'nivå 3: javascript feil',
            feilkode: error instanceof HelsenorgeProxyError ? error.response.code || error.statusCode.toString() : undefined,
            feilmelding: 'Uhåndtert teknisk feil',
        }));
        this.setState({ error: true });
        if (error instanceof HelsenorgeProxyError) {
            this.setState({ correlationId: error.correlationId });
        }
        if (isDebug() || import.meta.env.MODE !== 'production') {
            this.setState({ name: `${error.name} ${error.message}`, message: error.stack });
        }
        logError('Error in component', error);
    }
    render() {
        if (this.state.error) {
            if (typeof this.props.renderFallback === 'function') {
                return (_jsx(_Fragment, { children: this.props.renderFallback({ name: this.state.name, message: this.state.message, correlationId: this.state.correlationId }) }));
            }
            return _jsx(_Fragment, { children: this.props.renderFallback });
        }
        return _jsx(_Fragment, { children: this.props.children });
    }
}
export default ErrorBoundary;
